export default __webpack_public_path__ + "static/media/playlist.455ebb71.svg";